import {
  defaultFont,
  whiteColor,
  grayColor,
} from "assets/jss/material-dashboard-pro-react.js";

const actionDropdownStyle = (theme) => ({
  dropdown: {
    borderRadius: "4px",
    border: "1px solid #e8e8e8",
    boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
    top: "100%",
    zIndex: "1000",
    minWidth: "190px",
    padding: "4px 0",
    margin: "4px 0 0",
    fontSize: "13px",
    textAlign: "left",
    listStyle: "none",
    backgroundColor: whiteColor,
    backgroundClip: "padding-box",
  },
  dropdownItem: {
    ...defaultFont,
    fontSize: "13px",
    padding: "5px 12px 5px 18px",
    margin: "0",
    borderRadius: "0",
    position: "relative",
    transition: "all 150ms linear",
    display: "block",
    clear: "both",
    fontWeight: "400",
    height: "100%",
    color: grayColor[7],
    whiteSpace: "nowrap",
    minHeight: "unset",
  },
  clientHover: {
    "&:hover": {
      backgroundColor: theme.palette.custom.clientColor,
      color: theme.palette.custom.clientTextColor || whiteColor,
      "&:before": {
        color: theme.palette.custom.clientTextColor || whiteColor,
      },
    },
  },
  menuList: {
    padding: "0",
  },
  dropdownHeader: {
    display: "block",
    padding: "0 8px 6px 10px",
    fontSize: "0.75rem",
    lineHeight: "1.5em",
    color: grayColor[1],
    whiteSpace: "nowrap",
    fontWeight: "inherit",
    marginTop: "10px",
    minHeight: "unset",
    "&:hover,&:focus": {
      backgroundColor: "transparent",
      cursor: "auto",
    },
    pointerEvents: "none",
  },
  dropdownExplainer: {
    paddingLeft: "8px",
    paddingBottom: "3px",
  },
  dropdownItemActive: {
    "&:before": {
      color: theme.palette.custom.clientColor,
      position: "absolute",
      left: "7px",
      content: "'\\25cf'",
      fontSize: "13px",
      top: "50%",
      transform: "translateY(-50%)",
    },
  },
  dropdownDividerItem: {
    margin: "3px 0",
    backgroundColor: "#f0f0f0",
    height: "1px",
    overflow: "hidden",
  },
  popperClose: {
    pointerEvents: "none",
    display: "none !important",
  },
  popperResponsive: {
    zIndex: "1200",
    [theme.breakpoints.down("sm")]: {
      zIndex: "1640",
      position: "static",
      float: "none",
      width: "auto",
      marginTop: "0",
      backgroundColor: "transparent",
      border: "0",
      boxShadow: "none",
      color: "black",
    },
  },
});

export default actionDropdownStyle;
